/**
 * used for calculating pax configurations
 *
 * @type {{getRoomConfiguration: paxConfigurationCalculator.getRoomConfiguration, buildPaxConfiguration: paxConfigurationCalculator.buildPaxConfiguration, buildMaxPaxConfiguration: paxConfigurationCalculator.buildMaxPaxConfiguration}}
 */
var paxConfigurationCalculator = {
    getRoomConfiguration: function(paxConfiguration, maxPaxConfiguration, infantsTakeAvailability) {
        var sum = function(values) {
                return _.reduce(values, function(a, b) {
                    return a + b;
                }, 0)
            },
            rateMaxSum = sum([
                maxPaxConfiguration.adults,
                maxPaxConfiguration.children,
                maxPaxConfiguration.infants
            ]),
            totalPax = paxConfiguration.count(!infantsTakeAvailability),
            roomMax = rateMaxSum < maxPaxConfiguration.room ? rateMaxSum : maxPaxConfiguration.room,
            estimatedRoomCount = _.max([
                Math.ceil(totalPax / roomMax),
                Math.ceil(paxConfiguration.adults / maxPaxConfiguration.adults),
                maxPaxConfiguration.children ? Math.ceil(paxConfiguration.children / maxPaxConfiguration.children) : 0,
                maxPaxConfiguration.infants ? Math.ceil(paxConfiguration.infants / maxPaxConfiguration.infants) : 0
            ]),
            perRoom = {
                adults: Math.floor(paxConfiguration.adults / estimatedRoomCount),
                children: Math.floor(paxConfiguration.children / estimatedRoomCount),
                infants: Math.floor(paxConfiguration.infants / estimatedRoomCount)
            },
            extra = {
                adults: paxConfiguration.adults % estimatedRoomCount,
                children: paxConfiguration.children % estimatedRoomCount,
                infants: paxConfiguration.infants % estimatedRoomCount
            },
            roomConfiguration = [], i;

        if (estimatedRoomCount < 1) {
            return [];
        }

        // Fill the array with the rooms we know we have
        for(i = 0; i < estimatedRoomCount; i++) {
            roomConfiguration.push({
                adults: perRoom.adults,
                children: perRoom.children,
                infants: perRoom.infants
            });
        }

        // Now just loop while we have extra pax remaining
        while (sum(extra) > 0) {
            for (i = 0; i < estimatedRoomCount; i++) {
                _.each(extra, function(count, paxType) {
                    if (
                        count > 0 &&
                        (!maxPaxConfiguration[paxType] || roomConfiguration[i][paxType] < maxPaxConfiguration[paxType]) &&
                        sum(roomConfiguration[i]) < roomMax
                    ) {
                        extra[paxType]--;
                        roomConfiguration[i][paxType]++;
                    }
                });
            }
        }

        return roomConfiguration;
    },
    buildPaxConfiguration: function(adults, children, infants){
        return {
            adults: adults,
            children: children,
            infants: infants,
            // Add a method to the pax object to return a count
            count: function(excludeInfants, excludeChildren) {
                return this.adults + (excludeChildren ? 0 : this.children) + (excludeInfants ? 0 : this.infants);
            }
        };
    },
    buildMaxPaxConfiguration: function(adults, children, infants, roomMaxPax){
        return {
            adults: adults, 
            children: children,
            infants: infants, 
            room: roomMaxPax
        }
    }
};